import { render } from "./Spinner.vue?vue&type=template&id=72b12a5a&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=72b12a5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72b12a5a"

export default script